import React, { useCallback } from 'react';

import { getL10nDate } from '@travel/i18n';
import { cx } from '@travel/utils/src/classNames';

import labels from 'favoriteList/components/SearchForm/constants/labels';

import styles from './dateRow.module.scss';

export type DateButtonType = 'start' | 'end';

type Props = {
  className?: string;
  /** Node of start date title */
  title: string;
  date: string;
  isActive: boolean;
  type: DateButtonType;
  lang?: string;
  market?: string;
  onClick: (buttonType: DateButtonType) => void;
};

function DateButton(props: Props) {
  const { className, title, date, isActive, type, lang = 'ja-JP', market = 'JPN', onClick } = props;

  const subtitle = date
    ? getL10nDate(lang, date, 'YYYY/MM/DD(dd)', false, market)
    : isActive
      ? labels.pleaseSelect
      : '----/--/--';

  const handleClick = useCallback(() => {
    onClick(type);
  }, [onClick, type]);

  const isDisabled = !isActive && !date;

  return (
    <button
      data-testid="dateButton-button"
      type="button"
      onClick={handleClick}
      className={cx(
        className,
        styles.dateButton,
        isActive && styles.dateButtonActive,
        isDisabled && styles.dateButtonDisabled,
      )}
    >
      <div className={styles.dateButtonTitle}>{title}</div>
      <div className={styles.dateButtonSubtitle}>{subtitle}</div>
    </button>
  );
}

export default DateButton;
